export class V2ApiError extends Error {
  readonly code: string;
  readonly status: number;

  constructor(message: string, code: string, status: number) {
    super(message);
    this.name = 'V2ApiError';
    this.code = code;
    this.status = status;
    Object.setPrototypeOf(this, V2ApiError.prototype);
  }
}

export const isV2ApiError = (error: unknown): error is V2ApiError =>
  error instanceof V2ApiError ||
  (typeof error === 'object' &&
    error !== null &&
    typeof (error as Partial<V2ApiError>).code === 'string' &&
    typeof (error as Partial<V2ApiError>).status === 'number');

/**
 * The request left but no answer came back — timeout or a dropped connection.
 * Unlike a refusal, it says nothing about whether the server did the work.
 */
export class V2NoResponseError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'V2NoResponseError';
    Object.setPrototypeOf(this, V2NoResponseError.prototype);
  }
}
